module.exports = __webpack_public_path__ + "static/media/loader_gif.0372b1e5.gif";